module.exports = __webpack_public_path__ + "737033bc18b5651939c9579cf0b794a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/rainbow.png
// module id = 2325
// module chunks = 0